export default __webpack_public_path__ + "static/media/4.b1dc0f21.jpg";